export const trackerQueryKeys = {
  getAllTrackersByCompanyId: (companyId: string) => ['trackers', companyId],
  getTrackerDetailsById: (companyId: string, trackerId: string) => [
    'tracker-details',
    companyId,
    trackerId,
  ],
  getAllTasksByTrackerId: (companyId: string, trackerId: string, page: number, size: number) => [
    'tracker-tasks',
    companyId,
    trackerId,
    page,
    size,
  ],
  getCommentsByObjectId: (
    companyId: string,
    objectId: string,
    objectName: string,
    objectType: string,
  ) => ['task-comments', companyId, objectId, objectName, objectType],
};
